// extracted by mini-css-extract-plugin
export default {"main":"ExcelData_main__TRpyU","dropDown":"ExcelData_dropDown__I3eyF","paragraph":"ExcelData_paragraph__K+MS4","select":"ExcelData_select__21esw"};